module.exports = __webpack_public_path__ + "img/net-camera.03a0ab27.jpg";